<template>
  <div v-if="hasViewers" :class="{'larger-bottom-space' : largerBottomSpace}" class="whos-viewing-indicator">
    <template v-if="$screen.isTabletOrMobile($mq)">
      <div
        v-if="!mobileRevealClicked" 
        class="mobile-reveal-button" 
        @click="mobileRevealClicked=true"
      >
        <i class="ddi ddi-watching" />
      </div>
      <div v-else class="avatar-holder" @click="mobileRevealClicked=false">
        <i class="ddi ddi-watching" />
        <span>Viewing now:&nbsp;</span>
        <avatar-gallery
          :size="18"
          :people="viewers"
          :max-num-avatars="5"
          stack-tightly
        />
      </div>
    </template>
    <div v-else class="avatar-holder">
      <i class="ddi ddi-watching" />
      <span>Viewing now:&nbsp;</span>
      <avatar-gallery
        :size="18"
        :people="viewers"
        :max-num-avatars="5"
        stack-tightly
      />
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { IPersonBase } from '@/api/types/response.types'
import { defineComponent, markRaw } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import { pusherAuthHeaders } from '@/plugins/pusher'

/* Data types */

/* API */
import UserAPI from '@/api/modules/user.api'

export default defineComponent({
  name: 'WhosViewingIndicator',

  props: {
    itemId: {
      type: Number,
      required: true,
    },
    largerBottomSpace: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      /* Presence data ("Who's viewing ticket?") */
      presenceChannel: null as any,
      viewers: [] as IPersonBase[],
      mobileRevealClicked: false,
    }
  },

  computed: {
    pusherPresenceChannelID(): string {
      return `presence-item-detail-${this.itemId}`
    },
    hasViewers(): boolean {
      return this.viewers && this.viewers.length > 0 // "You" will always be there
    },
  },

  watch: {
    'presenceChannel.members.count': {
      immediate: true,
      handler(value) {
        if (!this.presenceChannel) {
          return
        }
        this.viewers = []
        // @ts-ignore
        this.presenceChannel.members.each(member => {
          if (this.$permissions.loggedInUser.id !== +member.id) {
            this.viewers.push({
              id: member.id,
              name: member.info.name,
              photoUrl: member.info.avatar_url,
            })
          }
        })
      },
    },
  },

  async created() {
    const authHeader = await UserAPI.get_PusherAuthHeaderValue()
    pusherAuthHeaders['X-Pusher-DD-Auth'] = authHeader.value
    // Raw, so Vue doesn't proxy Pusher's internals
    this.presenceChannel = markRaw(this.$pusher.subscribe(this.pusherPresenceChannelID))
  },

  beforeUnmount() {
    if (this.presenceChannel) {
      this.$pusher.unsubscribe(this.pusherPresenceChannelID)
    }
  },

  methods: {},
})
</script>


<style lang="scss">
.whos-viewing-indicator {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1050;

  animation-name: dd-bounce;
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 2;

  @include media-breakpoint-down(md) {
    bottom: 60px;
  }

  &.larger-bottom-space {
    bottom: 70px;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    @include flex-row-horizontal-spacing(4px);
    background-color: var(--color-background-secondary);
    border: $border--solid-medium;
    margin: 0 20px 20px 0;
    padding: 5px 10px;
  }

  .avatar-holder {
    @include lettering--p-sm--no-color;
    color: var(--color-text-secondary);
    border-radius: 20px;

    @include media-breakpoint-down(md) {
      padding: 10px;
    }
  }

  .mobile-reveal-button {
    .ddi {
      font-size: 18px;
    }
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>
